// extracted by mini-css-extract-plugin
module.exports = {"blog_body":"sidebar-styles-module--blog_body--3cu7H","widget_item":"sidebar-styles-module--widget_item--1yJjv","link":"sidebar-styles-module--link--3uvnn"};